import auroraColorPalette from '../colors';

export const toolbarPicker = {
  toolbar: {
    borderRadius: 0,
    boxShadow: 'inset 0 -30px 120px -30px rgba(0, 0, 0, 0.3)',
  },
};

export const clockPicker = {
  clock: {
    backgroundColor: 'none',
    border: `1px solid ${auroraColorPalette.primary.main}`,
  },
};

export const clockPickerPointer = {
  thumb: {
    boxShadow: `0 1px 10px 0px ${auroraColorPalette.primary.main}`,
  },
};

export const dTTabsPicker = {
  tabs: {
    backgroundColor: 'transparent',
    color: auroraColorPalette.primary.main,
  },
};
